export default __webpack_public_path__ + "images/WinterTaxesBackground.web.png";